/** The 17 primary palettes of @primeuix/themes (the grey ones are surfaces, not primary). */
export type ThemePalette =
  | 'emerald'
  | 'green'
  | 'lime'
  | 'red'
  | 'orange'
  | 'amber'
  | 'yellow'
  | 'teal'
  | 'cyan'
  | 'sky'
  | 'blue'
  | 'indigo'
  | 'violet'
  | 'purple'
  | 'fuchsia'
  | 'pink'
  | 'rose';

// Change the color here: one of the 17 palettes ('purple' is the previous look).
export const THEME_PRIMARY: ThemePalette = 'lime';

// Palette of the info tags («Vigente»…); Lara's default is 'sky'.
export const THEME_INFO: ThemePalette = 'cyan';
